const themeConfig = {
	cloverleaf: {
		brand: {
			logoFooter: "/vertical-logo.png",
			size: 115,
			logoFooterSize: 177,
			footerPaddingTop: 0.001,
			footerPaddingBottom: 0.001,
		},
		navbar: {
			height: 109,
		},
		newsletter: false,
		components: {
			Slider: {
				autoplay: 12000,
				animationDuration: 3200,
			},
		},
    css: `
      #___gatsby a[target="_blank"]::after {
        content: none;
      } 
    `
	},
};
module.exports = themeConfig;
